/**
 * 손을 뗄 때 '시작 대기(ready)' 드래그 때문에 Konva가 하는 전체 동기 그리기를 없앤다.
 *
 * Konva 9는 포인터를 누르면 draggable 노드(스테이지 팬 포함)를 `DD._dragElements`에 'ready'로 올리고, 떼면
 * window 캡처 리스너 `DD._endDragBefore`가 그 노드의 레이어(스테이지면 스테이지 전체)를 `draw()`로 동기
 * 그린다 — 한 번도 움직이지 않은 대기 드래그여도 그린다. 탭 한 번마다 화면 변화 없는 전체 scene+hit 그리기가
 * 생겼다(A21s 도형 많은 층 ≈35~45ms, 결함 선택 추적). 대기 드래그는 어차피 `_endDragAfter`가 아무 이벤트 없이 지우고
 * (`dragStatus !== 'dragging'`이면 삭제), Konva도 draggable을 끌 때 대기 드래그는 지우기만 한다(`_dragChange`).
 * 그래서 Konva 리스너 바로 앞에서, 이번에 뗀 포인터의 대기 드래그만 같은 방식(삭제)으로 먼저 지운다.
 * stopDrag()는 쓰지 않는다 — 상태를 'stopped'로 바꾸고 `_endDragBefore`를 불러 그리기·탭 억제가 그대로 생긴다.
 */
import { DD } from 'konva/lib/DragAndDrop'

// Konva가 드래그 요소의 pointerId와 비교하는 값(Stage.setPointersPositions·Util._getFirstPointerId와 같음)
function releasedPointerIds(evt: Event): unknown[] {
  const touches = (evt as TouchEvent).changedTouches
  if (touches !== undefined) return Array.from(touches, touch => touch.identifier)
  return [(evt as PointerEvent).pointerId || 999]
}

function dropReadyDrags(evt: Event): void {
  if (DD._dragElements.size === 0) return
  const ids = releasedPointerIds(evt)
  DD._dragElements.forEach((elem, key) => {
    if (elem.dragStatus === 'ready' && ids.includes(elem.pointerId)) DD._dragElements.delete(key)
  })
}

// Konva 리스너보다 먼저 돌도록 떼었다가 우리 것 뒤에 다시 붙인다(같은 대상·단계는 등록 순서대로 호출)
if (typeof window !== 'undefined') {
  for (const type of ['mouseup', 'touchend', 'touchcancel']) {
    window.removeEventListener(type, DD._endDragBefore, true)
    window.addEventListener(type, dropReadyDrags, true)
    window.addEventListener(type, DD._endDragBefore, true)
  }
}
